import React from 'react';
import { Modal } from 'react-bootstrap';

export default (props) => (
  <Modal
    className="copyright-certain-works-modal"
    show={props.open}
    onHide={() => props.onClose()}
  >
    <Modal.Body>
      <div>
        <p>
          <strong>
            Several categories of material are generally not eligible for
            federal copyright protection. These include among others:
          </strong>
        </p>
        <ul>
          <li>
            works that have not been fixed in a tangible form of expression (for
            example, choreographic works that have not been notated or recorded,
            or improvisational speeches or performances that have not been
            written or recorded)
          </li>
          <li>
            titles, names, short phrases, and slogans; familiar symbols or
            designs; mere variations of typographic ornamentation, lettering, or
            coloring; mere listings of ingredients or contents
          </li>
          <li>
            ideas, procedures, methods, systems, processes, concepts,
            principles, discoveries, or devices, as distinguished from a
            description, explanation, or illustration
          </li>
          <li>
            works consisting entirely of information that is common property and
            containing no original authorship (for example: standard calendars,
            height and weight charts, tape measures and rulers, and lists or
            tables taken from public documents or other common sources)
          </li>
        </ul>
      </div>
    </Modal.Body>
  </Modal>
);



// WEBPACK FOOTER //
// src/components/Copyright/CertainWorksPopup.jsx